import { z } from 'zod';

const text = (max: number) =>
  z.string().trim().max(max, { error: 'inventory:locations.validation.tooLong' });

/** The address is optional as a whole; once any line is typed, line 1, city and country count. */
export const locationFormSchema = z
  .object({
    name: z
      .string()
      .trim()
      .min(1, { error: 'inventory:locations.validation.nameRequired' })
      .max(120, { error: 'inventory:locations.validation.tooLong' }),
    line1: text(200),
    line2: text(200),
    city: text(120),
    region: text(120),
    postalCode: text(20),
    countryCode: z.string().trim().toUpperCase(),
    fulfillsOnlineOrders: z.boolean(),
    isDefault: z.boolean(),
  })
  .superRefine((v, ctx) => {
    const typed = [v.line1, v.line2, v.city, v.region, v.postalCode, v.countryCode].some(
      (part) => part !== '',
    );
    if (!typed) return;
    for (const field of ['line1', 'city'] as const) {
      if (v[field] === '') {
        ctx.addIssue({
          code: 'custom',
          path: [field],
          message: 'inventory:locations.validation.addressIncomplete',
        });
      }
    }
    if (!/^[A-Z]{2}$/.test(v.countryCode)) {
      ctx.addIssue({
        code: 'custom',
        path: ['countryCode'],
        message: 'inventory:locations.validation.country',
      });
    }
  });

export type LocationFormInput = z.input<typeof locationFormSchema>;
export type LocationFormOutput = z.output<typeof locationFormSchema>;
